import axios from "axios";

/* OUTSIDE OF STRIPE SOLUTION */
const apiUrl = process.env.REACT_APP_API_URL;

const updateInvoiceStatus = async (invoiceId: number, status: string) => {
    try {
        const response = await axios.post(`${apiUrl}/Invoice/update-invoice-status`, { invoiceId, status });
        return response.data;
    } catch (error: any) {
        throw new Error(`Error updating invoice status: ${error.message}`);
    }
};

export default updateInvoiceStatus;